import React from 'react';
import { Select } from 'components';
import styled from 'styled-components';
import { FeedbackInputProps } from '../types';
import { FEEDBACK_MODAL_SELECT_ZINDEX } from '../constants';

type FeedbackSelectProps = FeedbackInputProps;

const FeedbackSelect: React.FC<FeedbackSelectProps> = ({
  disabled,
  index,
  template: { options, response },
  onChange,
}) => {
  const _onChange = (value: string) => {
    onChange(value);
  };

  const selectOptions = options.map((option, i) => ({
    key: i,
    value: option,
    label: option,
  }));

  return (
    <FullWidthSelect
      id={`feedback-template-${index}`}
      disabled={disabled}
      onChange={_onChange}
      options={selectOptions}
      value={response}
      dropdownStyle={{
        zIndex: FEEDBACK_MODAL_SELECT_ZINDEX,
      }}
    />
  );
};

const FullWidthSelect = styled(Select)`
  width: 100%;
`;

export default FeedbackSelect;
